import {useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CircledIcon from '../../../components/CircledIcon';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Label from '../../../components/Label/Label';
import IconButton from '../../../components/IconButton';
import PopoverWithLinks from '../../widgets/PopoverLinks/PopoverLinks';


const FlexibleSpendingAccounts = () => {
  const [showDetails, setShowDetails] = useState<boolean>(false);
  
  const [showDetails2, setShowDetails2] = useState<boolean>(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };
  const toggleDetails2 = () => {
    setShowDetails2(!showDetails2);
  };

  return (
    <Container className={'px-0'}>
      <Row className={'mt-8'}>
          <Col className={'col-12 col-lg-6'}>
              <h6 className="text-20 pb-0 mb-0">Flexible Spending Accounts</h6>
          </Col>
      </Row>
      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
  
            <Row className={'mt-0'}>
              <Col className={'col-12'}>
                
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('heart-pulse')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                    
                    <div className="ms-4">
                      <h5>Dependent Care Flexible Spending Account</h5>
                    </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails2}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails2}
                      >
                        Benefits Info
                      </Label>
                    </div>
                  </div>
                  <Row className={`expandable-wrapper mt-10 ${showDetails2 ? 'open' : ''}`}>
                    <div className="w-100 justify-content-center">

                    <Card
                      bg={'blue'}
                      key={'Primary'}
                      text={'white'}
                      style={{ width: '18rem' }}
                      className="bg-primary w-100 mb-12"
                    >
                      <Card.Body>
                        <Card.Text>
                          <ul>
                            <li>In 2025, you may contribute up to $5,000 pre-tax to pay for certain eligible dependent care expenses. Qualified work-related day care expenses are eligible for reimbursement only for children or other eligible dependents who are under 13 and qualify as your tax dependent.</li>
                            <li>For additional information and resources for childcare visit Care.com.</li>
                          </ul>

                        </Card.Text>
                      </Card.Body>
                    </Card>

                    </div>
                  </Row>
            
            <div>
              <GenericCard variant='transperant' className={'border rounded-1 custom-blockquote primary'}>
                
                  <Row
                      key='1'
                      className={
                        'py-0 my-0 text-fs-6  lh-xs'
                      }
                    >  
                      <Col lg={3} className="text-center">
                      <strong> Minimum Annual Contribution </strong> <br></br>
                      $120.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong> Maximum Annual Contribution</strong><br></br>
                      $5,000.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Increment</strong> <br></br>$1.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Your Election Per-pay-period</strong> Not Contributing
                      </Col> 
                 </Row>
              </GenericCard>
            </div>
          
              </Col>
            </Row>
           
          </GenericCard>
        </Col>
      </Row>

      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
  
            <Row className={'mt-0'}>
              <Col className={'col-12'}>
                
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('heart-pulse')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                    
                    <div className="ms-4">
                      <h5>Limited Purpose Flexible Spending Account</h5>
                    </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails}
                      >
                        Benefits Info
                      </Label>
                    </div>
                  </div>
                  <Row className={`expandable-wrapper mt-10 ${showDetails ? 'open' : ''}`}>
                    <div className="w-100 justify-content-center">

                    <Card
                      bg={'blue'}
                      key={'Primary'}
                      text={'white'}
                      style={{ width: '18rem' }}
                      className="bg-primary w-100 mb-12"
                    >
                      <Card.Body>
                        <Card.Text>
                          <ul>
                            <li>If you enroll in a high deductible medical option and want to contribute to Delta’s Healthcare FSA, your FSA will be a Limited Purpose FSA.</li>
                            <li>In 2025, you may contribute up to $3,300 pre-tax to pay for certain eligible healthcare expenses that are not covered by other insurance plans.</li>
                          </ul>

                        </Card.Text>
                      </Card.Body>
                    </Card>

                    </div>
                  </Row>
            
            <div>
              <GenericCard variant='transperant' className={'border rounded-1 custom-blockquote primary'}>
                
                  <Row
                      key='1'
                      className={
                        'py-0 my-0 text-fs-6  lh-xs'
                      }
                    >  
                      <Col lg={3} className="text-center">
                      <strong> Minimum Annual Contribution </strong> <br></br>
                      $120.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong> Maximum Annual Contribution</strong><br></br>
                      $3,200.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Increment</strong> <br></br>$1.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Your Election Per-pay-period</strong> Not Contributing
                      </Col> 
                 </Row>
              </GenericCard>
            </div>
          
              </Col>
            </Row>
           
          </GenericCard>
        </Col>
      </Row>


    </Container>
  )
}

export default FlexibleSpendingAccounts